export const isEmptyObject = (obj: any) => obj != null && Object.keys(obj).length === 0;

/**
 * Returns a deterministic hash (hex string) of the provided data.
 * This is a fast, dependency-free 32-bit hash suitable for IDs and cache keys.
 * Note: Not cryptographically secure.
 */
export const getHash = (data: string): string => {
  let hash = 0;
  for (let i = 0; i < data.length; i++) {
    hash = (hash << 5) - hash + data.charCodeAt(i);
    hash |= 0; // Convert to 32-bit integer
  }
  // Convert to unsigned and then to hex string
  return (hash >>> 0).toString(16);
};

/**
 * Clears user-related data from browser storage used in the funnel.
 * Currently removes only the 'emailAddress', 'click_ids', 'user_language' keys from localStorage.
 */
export const clearBrowserStorage = (): void => {
  try {
    if (typeof window !== 'undefined' && 'localStorage' in window) {
      window.localStorage.removeItem('click_ids');
      window.localStorage.removeItem('user_language');
      window.localStorage.removeItem('emailAddress');
    }
  } catch (e) {
    // Fail silently if storage is not accessible (e.g., in private mode)
  }
};
